export default __webpack_public_path__ + "static/media/step2.5ea77d52.png";